import * as tslib_1 from "tslib";
import * as React from 'react';
import { List, ListItem } from 'material-ui/List';
import { Divider, IconButton, FontIcon } from 'material-ui';
import { grey500, grey100 } from 'material-ui/styles/colors';
import { copyTextToClipBoard } from 'src/utils/dom';
import { inject } from 'mobx-react';
import { BASE_URL } from 'src/api';
var dateFormat = function (dateString) { return new Date(dateString)
    .toLocaleDateString('hu'); };
var styles = {
    badge: {
        backgroundColor: grey100,
        borderRadius: '3px',
        padding: '3px',
        marginLeft: '.5rem'
    }
};
var DocumentAction = function (props) { return (React.createElement(IconButton, { tooltip: props.tooltip, tooltipPosition: "top-center", onClick: function (e) { return props.onClick(props.document); } },
    React.createElement(FontIcon, { color: grey500, className: "material-icons" }, props.icon))); };
var documentLink = function (document) { return document.isLocal
    ? "file:///" + document.fileName + document.fileExtension
    : BASE_URL + "/documents/download/" + document.id; };
var TaskDocumentList = /** @class */ (function (_super) {
    tslib_1.__extends(TaskDocumentList, _super);
    function TaskDocumentList(props) {
        var _this = _super.call(this, props) || this;
        _this.handleClick = function (document) {
            var link = documentLink(document);
            if (!document.isLocal) {
                window.open(link);
            }
            else {
                copyTextToClipBoard(link);
                _this.props.userStore.notify('A dokumentum lokális linkje a vágolapra másolva!');
            }
        };
        return _this;
    }
    TaskDocumentList.prototype.render = function () {
        var _this = this;
        var _a = this.props, documents = _a.documents, onDelete = _a.onDelete;
        if (!documents || documents.length === 0) {
            return null;
        }
        var items = documents.map(function (document) { return (React.createElement("div", { key: document.id },
            React.createElement(ListItem, { primaryText: document.name, secondaryText: (document.description || '-'), rightAvatar: (React.createElement("div", { className: "right" },
                    React.createElement("div", null,
                        React.createElement("small", { style: styles.badge }, dateFormat(document.created)),
                        React.createElement("small", { style: styles.badge },
                            "v.",
                            document.version)),
                    React.createElement(DocumentAction, { icon: "pageview", tooltip: "Megtekint\u00E9s", document: document, onClick: _this.handleClick }),
                    React.createElement(DocumentAction, { icon: "delete", tooltip: "T\u00F6rl\u00E9s", document: document, onClick: onDelete }))) }),
            React.createElement(Divider, null))); });
        return React.createElement(List, null, items);
    };
    TaskDocumentList = tslib_1.__decorate([
        inject('userStore')
    ], TaskDocumentList);
    return TaskDocumentList;
}(React.Component));
export default TaskDocumentList;



//////////////////
// WEBPACK FOOTER
// ./src/pages/tasks/TaskDocumentList.tsx
// module id = 736
// module chunks = 0